import { endpoint } from '@library/endpoint'

import { fetch } from 'utils/fetch'

type reqDataInput = {
  email: string
  promocode: string
  step: string
  user_name_first: string
  user_name_last: string
  allow_marketing_email: boolean
  preview_order_id: string
}

export function storeProspect(reqData: reqDataInput) {
  return fetch(null, `${endpoint('core')}/prospect`, reqData, 'POST')
}
